import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  /** Compact status next to the title (e.g. Last sync · Loaded). */
  meta?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, description, meta, actions }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div className="page-header__top">
        <div className="page-header__title-block">
          <h1 className="page-title">{title}</h1>
          {meta ? <div className="page-header__meta">{meta}</div> : null}
        </div>
        {actions ? <div className="page-header__actions">{actions}</div> : null}
      </div>
      {description ? <p className="page-lead">{description}</p> : null}
    </header>
  );
}
